import React from 'react';
import { ArrowRightIcon, PhoneIcon } from 'lucide-react';
export function FinalCTA() {
  return <section className="relative py-24 md:py-32 px-6 md:px-12 lg:px-16 overflow-hidden group" data-id="element-78">
      {/* Background Image & Overlays with Parallax-like scale */}
      <div className="absolute inset-0 z-0 overflow-hidden" data-id="element-79">
        <img src="https://cdn.magicpatterns.com/uploads/37K5Wp4b55sg4NTubwdUuJ/7AA8D80C-2208-4B23-83B7-CD7C582B47C7.png" alt="Florida single family home with palm trees" className="w-full h-full object-cover scale-110 transition-transform duration-[10s] group-hover:scale-100" data-id="element-80" />
        <div className="absolute inset-0 bg-[#1B2A4A]/75" data-id="element-81" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(232,145,58,0.2)_0%,transparent_70%)]" data-id="element-82" />
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-83">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white mb-8 tracking-tight leading-tight" data-id="element-84">
          Ready to Sell? <br className="hidden md:block" data-id="element-85" />
          Let's Make It Happen.
        </h2>

        <p className="text-xl text-slate-300 mb-12 max-w-2xl mx-auto font-light leading-relaxed" data-id="element-86">
          We can only take on a limited number of properties each month. Get
          your fair cash offer today before our spots fill up.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-16" data-id="element-87">
          <button onClick={() => window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })} className="w-full sm:w-auto bg-[#E8913A] hover:bg-[#D17E2E] text-white font-bold py-4 px-10 rounded-md transition-colors flex items-center justify-center group/btn text-lg shadow-lg" data-id="element-88">
            Request Your Offer
            <ArrowRightIcon className="w-5 h-5 ml-2 group-hover/btn:translate-x-1 transition-transform" data-id="element-89" />
          </button>

          <a href="tel:8883417570" className="w-full sm:w-auto bg-white/10 hover:bg-white/20 text-white font-bold py-4 px-10 rounded-md transition-colors flex items-center justify-center text-lg backdrop-blur-md border border-white/10" data-id="element-90">
            <PhoneIcon className="w-5 h-5 mr-3" data-id="element-91" />
            Call (888) 341-7570
          </a>
        </div>

        <div className="pt-8 border-t border-white/10 max-w-sm mx-auto" data-id="element-92">
          <span className="text-white/80 text-sm font-medium tracking-wide uppercase" data-id="element-93">
            Serving Florida homeowners since 2015
          </span>
          <p className="text-sm text-slate-400 mt-2" data-id="element-94">
            No obligation. No fees. 100% confidential.
          </p>
        </div>
      </div>
    </section>;
}